import { FunctionComponent  } from 'react';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageHomeSectionInfo: FunctionComponent<Props> = ({ translations: { title, description } }) => {
    return (
        <StyledComponent className="public-page-company-sites-section-info">
            <header>
                <h2
                    className="title"
                    dangerouslySetInnerHTML={{ __html: title }}
                />
            </header>
            <section>
                <p dangerouslySetInnerHTML={{ __html: description }} />
            </section>
        </StyledComponent>
    );
};

export default PublicPageHomeSectionInfo;
